import { Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

/**
 * Preload the default language. A failed load must not abort bootstrap:
 * no template reads translations, so the app can run without them.
 */
export const preloadDefaultLang = (translocoService: TranslocoService): () => Promise<Translation | null> => (): Promise<Translation | null> => {
    const defaultLang = translocoService.getDefaultLang();
    translocoService.setActiveLang(defaultLang);
    return translocoService.load(defaultLang).pipe(
        catchError((error) => {
            console.error('[Transloco] Failed to load default language; continuing without translations', error);
            return of(null);
        })
    ).toPromise();
};

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        {
            // Provide the default Transloco configuration
            provide : TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English'
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish'
                    }
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            })
        },
        {
            // Provide the default Transloco loader
            provide : TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide   : APP_INITIALIZER,
            deps      : [TranslocoService],
            useFactory: preloadDefaultLang,
            multi     : true
        }
    ]
})
export class TranslocoCoreModule
{
}
